import {createContext, useCallback, useContext, useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {selectInventory} from "../constant/selectors";
import {disableItem, getInventory, getInventoryQuantity, initData, AddToCartForOder,AddToValidationCartForOder,UpdateBadgeForOder} from "../redux/slices/inventory/inventory.thunks";
import {isNot} from "../shared/functions/types_check";
import {INVENTORY_FILTER_DEFAULT} from "../constant/inventory";
import {addMetaData, filterList} from "../utils/inventory"; 

import useUsers from "../hooks/useUsers";

export const InventoryContext = createContext(null)

export const useInventory = () => useContext(InventoryContext);
export function InventoryProvider({children}) {
    const dispatch = useDispatch();
    const {list, loading, initialized, hasMore, shipping, receiving, pos} = useSelector(selectInventory);
    const [shippingLoading, setShippingLoading] = useState(false)
    const [receivingLoading, setReceivingLoading] = useState(false)
    const [filters, setFilters] = useState(INVENTORY_FILTER_DEFAULT)
    const [keyword, setKeyword] = useState('')

    const metaData = useMemo(() => addMetaData(list, shipping, receiving, pos), [list, shipping, receiving, pos])
    const data = useMemo(() => filterList(metaData, keyword), [metaData, keyword])
    const { userInfo ,  } = useUsers();
    // console.log(metaData)
    // console.log(data)

    const shouldLoading = useMemo(() => {
        return loading || shippingLoading || receivingLoading;
    }, [loading, receivingLoading, shippingLoading])

    const handleData = useCallback((loadMore = false) => {
        // console.log("CONTEXT = vendorId = "+JSON.stringify(filters));
        dispatch(getInventory(filters, loadMore, 100, null))
    }, [dispatch, filters])

    const handleLoadMore = () => hasMore && handleData(true)

    const handleHidde = ids => {
        dispatch(disableItem(ids, () => {
            dispatch(getInventory(filters))
        }))
    }

    const handleAddToCartForFutureOder = ids => {
        console.log(ids,userInfo,filters)
        dispatch(AddToCartForOder(ids, userInfo, () => {
            dispatch(getInventory(filters))
        }))
    }

    const handleAddToValidationCartForFutureOder = ids => {
        console.log(ids,userInfo,filters)
        dispatch(AddToValidationCartForOder(ids, userInfo, () => {
            dispatch(getInventory(filters))
        }))
    }

    const handleUpdateBadgeForFutureOder = ids => {
        console.log(ids,userInfo,filters)
        dispatch(UpdateBadgeForOder(ids, userInfo, () => {
            dispatch(getInventory(filters))
        }))
    }
    
    /*
    const handleDisableAction = ids => {
        dispatch(disableItem(ids, () => { 
            dispatch(DisableProductInventory(ids))
        }))
    }*/

    useEffect(() => {
        if (isNot(initialized)) {
            setShippingLoading(true)
            setReceivingLoading(true)

            dispatch(initData(
                () => setShippingLoading(false),
                () => setReceivingLoading(false)
                )
            )

        }
    }, [dispatch, initialized])

    useEffect(() => {
        handleData()
    }, [filters, handleData])

    const [aaa , setAaaa]=useState(filters.value);

    return (
        <InventoryContext.Provider value={{
            aaa,
            data,
            exportData: [],
            loading: shouldLoading,
            filters, setFilters,
            keyword, setKeyword,
            hasToBuy: true,
            warehouses: ['Dekon', 'Cassablanca'],
            loadMore: handleLoadMore,
            hide: handleHidde,
            addToCartForFutureOder: handleAddToCartForFutureOder,
            addToValidationCartForFutureOder: handleAddToValidationCartForFutureOder,
            UpdateBadgeForOder:handleUpdateBadgeForFutureOder
        }}>
            {children}
        </InventoryContext.Provider>
    )
}


export function QtyForMonthProvider({children}) {
    const dispatch = useDispatch();

    const {list, loading, initialized, hasMore, shipping, receiving, pos} = useSelector(selectInventory);
    const [shippingLoading, setShippingLoading] = useState(false)
    const [receivingLoading, setReceivingLoading] = useState(false)
    const [filters, setFilters] = useState(INVENTORY_FILTER_DEFAULT)
    const [keyword, setKeyword] = useState('')

    const metaData = useMemo(() => addMetaData(list, shipping, receiving, pos), [list, shipping, receiving, pos])
    const data = useMemo(() => filterList(metaData, keyword), [metaData, keyword])
    // console.log(metaData)
    // console.log(data)

    const shouldLoading = useMemo(() => {
        return loading || shippingLoading || receivingLoading;
    }, [loading, receivingLoading, shippingLoading])

    const handleData = useCallback((loadMore = false) => {
        // console.log("CONTEXT = vendorId = "+JSON.stringify(filters));
        dispatch(getInventoryQuantity(filters, loadMore, 100, null))
    }, [dispatch, filters])

    const handleLoadMore = () => hasMore && handleData(true)

    const handleHidde = ids => {
        dispatch(disableItem(ids, () => {
            dispatch(getInventoryQuantity(filters))
        }))
    }

    const handleAddToCartForFutureOder = ids => {
        dispatch(AddToCartForOder(ids, () => {
            dispatch(getInventoryQuantity(filters))
        }))
    }
    const handleAddToValidationCartForFutureOder = ids => {
        dispatch(AddToValidationCartForOder(ids, () => {
            dispatch(getInventoryQuantity(filters))
        }))
    }

    const handleUpdateBadgeForFutureOder = ids => {
        dispatch(UpdateBadgeForOder(ids, () => {
            dispatch(getInventoryQuantity(filters))
        }))
    }
    
    /*
    const handleDisableAction = ids => {
        dispatch(disableItem(ids, () => { 
            dispatch(DisableProductInventory(ids))
        }))
    }*/

    useEffect(() => {
        if (isNot(initialized)) {
            setShippingLoading(true)
            setReceivingLoading(true)

            dispatch(initData(
                () => setShippingLoading(false),
                () => setReceivingLoading(false)
                )
            )

        }
    }, [dispatch, initialized])

    useEffect(() => {
        handleData()
    }, [filters, handleData])
    console.log('FFFF',data)
    return (
        <InventoryContext.Provider value={{
            data,
            exportData: [],
            loading: shouldLoading,
            filters, setFilters,
            keyword, setKeyword,
            hasToBuy: true,
            warehouses: ['Dekon', 'Cassablanca'],
            loadMore: handleLoadMore,
            hide: handleHidde,
            addToCartForFutureOder: handleAddToCartForFutureOder,
            addToValidationCartForFutureOder: handleAddToValidationCartForFutureOder,
            UpdateBadgeForOder:handleUpdateBadgeForFutureOder

        }}>
            {children}
        </InventoryContext.Provider>
    )
}